import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { useQuery } from '@apollo/client';
import { Center, Spinner } from '@chakra-ui/react';
import { WireInstructionDocument } from '@common/graphql/generated';
import { Button } from '../common/Button';
import { FlexCol } from '../common/Flex';
import { Paragraph } from '../common/Typography';

export type WireInstructionModalProps = {
    goalAccountId: string;
};

export const showWireInstructionModal = (props: WireInstructionModalProps) =>
    ModalManager.show(WireInstructionModal, props);

const WireInstructionModal = ModalManager.create<WireInstructionModalProps>(
    ({ goalAccountId }) => {
        useTrackModalShown('Goal Wire Instruction');

        const modal = useModal();

        const { data, loading } = useQuery(WireInstructionDocument, {
            variables: { financialEntityId: goalAccountId },
            fetchPolicy: 'network-only',
        });
        const wireInstruction = data?.wireInstruction;

        let title: string | undefined;
        let content: JSX.Element;
        if (wireInstruction) {
            title =
                'Move your account by providing your wire account details to your current provider:';
            content = (
                <FlexCol>
                    <Paragraph fontWeight="semibold">
                        Bank Name & Address
                    </Paragraph>
                    <Paragraph>{wireInstruction.bankName}</Paragraph>
                    <Paragraph>{wireInstruction.address}</Paragraph>
                    <Paragraph fontWeight="semibold" mt={4}>
                        Account Name
                    </Paragraph>
                    <Paragraph>{wireInstruction.accountHolder}</Paragraph>
                    <Paragraph fontWeight="semibold" mt={4}>
                        Wire Memo
                    </Paragraph>
                    <Paragraph>{wireInstruction.memorandum}</Paragraph>
                    <Paragraph fontWeight="semibold" mt={4}>
                        Routing Number
                    </Paragraph>
                    <Paragraph>{wireInstruction.routingNumber}</Paragraph>
                    <Paragraph fontWeight="semibold" mt={4}>
                        Account Number
                    </Paragraph>
                    <Paragraph>{wireInstruction.accountNumber}</Paragraph>
                    <Button
                        onClick={modal.remove}
                        onClickEvent="Wire Instruction Close Button Clicked"
                        mt={4}
                        alignSelf="flex-end"
                    >
                        Close
                    </Button>
                </FlexCol>
            );
        } else if (loading) {
            content = (
                <Center minH={500}>
                    <Spinner />
                </Center>
            );
        } else {
            content = (
                <Paragraph color="textMuted">
                    Wire instructions are currently unavailable. Please try
                    again later.
                </Paragraph>
            );
        }

        return (
            <Modal
                title={title}
                size="md"
                isOpen={modal.visible}
                onClose={modal.remove}
            >
                {content}
            </Modal>
        );
    }
);

export default WireInstructionModal;
